import { initCheckbox } from "../../../components/checkbox/checkbox";
import { Gamecloud } from '../../gamecloud';
import { ConfigurationUI, createConfigurationUI } from './configurationUI';
import { Notification } from '../../../notification/notfication';
import Axios from 'axios';
import { Expertmode } from './submodules/expertmode/expertmode';
import { ServerStatus } from '../../interface';
import { initServerType } from './submodules/servertype/servertype';
import { initLayoutSwitcher } from './submodules/layout_switcher/LayoutSwitcher';
import { initLinkingVars } from './submodules/linkingVars/linkingVars';
import { Server } from '../../../units/server/server';
import ServerInterface = Server.ServerInterface;
import ServerEventType = Server.ServerEventType;
import Utils from '../../../utils/utils';
import i18next from 'i18next';

class Configuration extends Gamecloud {

    private form: any;

    public constructor(private ui: ConfigurationUI) {
        super();
        this.handleConfigurationOnStateChange();
    }

    /**
     * Send API request to fetch data
     * Needed to render the input fields dynamically
     */
    private fetchConfiguration() {
        if (this.ui.isConfigurationEnabled()) {
            return;
        }
        this.ui.showElementsIfServerOnline();
        this.ui.enableConfiguration();
        const gameserverId = window.gameserverId;
        Axios.post(window.ajaxPath + '/getFormConfiguration', {}, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-Requested-With': 'XMLHttpRequest'
            }
        }).then((response) => {
            this.form = response.data;
            this.ui.render(response.data, this.afterRender.bind(this));
            this.ui.onSubmit(this.save.bind(this));
            window.checkboxes = initCheckbox();
            if (window.disableConfigSave !== undefined && window.disableConfigSave === 1) {
                this.ui.disableSubmitButton();
            }
        });
    }

    /**
     * this method will be used to hide & show configuration when a specific game requires
     * it (the configWhenRunning comes from the Controller of the Game)
     */
    private handleConfigurationOnStateChange(): void {
        this.fetchConfiguration();
        window.addEventListener(ServerEventType.GAMESERVERINITIALISED_EVENT, () => {
            let currentGameserver: ServerInterface = Server.Gameserver.getActiveServer();

            currentGameserver.stateEvent.addEventListener(
                ServerEventType.STATECHANGE_EVENT, (state: Server.IStateEvent) => {
                    this.handleFormElements(state);
                }
            );
        });
    }

    /**
     * handel form elements based on the $configWhenRunning from controller
     */
    private handleFormElements(state): void {
        switch (state.newstate.stateId) {
            case ServerStatus.Stopped:
                this.fetchConfiguration();
                break;

            case ServerStatus.Running:
                if (window.configWhenRunning) {
                    this.fetchConfiguration();
                } else {
                    this.ui.hideElementsIfServerOnline();
                    this.ui.disableConfiguration();
                }
                break;

            default:
                this.fetchConfiguration();
                break;
        }
    }

    /**
     * Callback function
     * Called after the ui.render method
     */
  private afterRender() {
    this.ui.onSearchInput(this.searchForSettings.bind(this));
    this.ui.onScroll(this.toggleSettingsBarStickyBehavior.bind(this));
    this.ui.onDeleteSavesgames(this.deleteSavegames.bind(this));
    this.ui.onDeleteCharcacters(this.deleteCharacters.bind(this));
    this.ui.onResetServerSettingsToDefault(this.resetServerSettingsDefault.bind(this));
    this.readConfig();
  }

  /**
   * Callback function after the user input something in the serachfield
   * @param value
   */
  private searchForSettings(value: string) {
    this.ui.search(value);
  }

  /**
   * Toggle settingsbar sticky behavior
   */
  private toggleSettingsBarStickyBehavior(scrolltop: number) {
      if (scrolltop > 163) {
      this.ui.setSettingsBarSticky(true);
    } else {
      this.ui.setSettingsBarSticky(false);
    }
  }

  /**
   * Submit the settings
   */
  private save() {
    const ajaxUrl: string = window.ajaxPath + '/writeConfig';
    this.loader.enable();
    Axios.post(ajaxUrl, Utils.getFromData('gameserver-settings'), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then((response) => {
      this.loader.disable();
      const { action, new_savegame_name } = response.data;
      let notificationText = i18next.t('gameserver:configuration.save.notifications.success.text');
      if (action == 'savegame_change') {
        notificationText += `<br>${
          i18next.t(
            'gameserver:configuration.savegame_change_loaded.notifications.success.text',
            { savegameName: new_savegame_name },
          )
        }`;
      }
      new Notification('success', i18next.t('gameserver:configuration.save.notifications.success.title'),
        notificationText
      );
    }).catch(() => {
        this.loader.disable();
        new Notification('danger',
            i18next.t('gameserver:configuration.save.notifications.error.title'),
            i18next.t('gameserver:configuration.save.notifications.error.text')
        );
    });
  }

    /**
     * Read saved configuration and update the UI
     */
    private readConfig() {
        const ajaxUrl: string = window.ajaxPath + '/readConfig';
        Axios.post(ajaxUrl, {}, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-Requested-With': 'XMLHttpRequest'
            }
        }).then((response) => {
            initLinkingVars(this.form, response.data);
            this.ui.updateValues(response.data).then(() => {
                this.ui.initModification(response.data, this.form);
                this.ui.initTableview(response.data, this.form);

                if (this.isBF()) {
                  this.ui.initBF4Mapcycle(response.data.virtual.mapCycle, this.form.sections.mapCycle.variables);
                  this.ui.initPreset(response.data, this.form, this.afterRender.bind(this));
                } else if (this.isSquad()) {
                  this.ui.initSquadMapcycle(response.data.virtual.levels, response.data.virtual.layers, this.form.sections.mapCycle.variables);
                } else if (typeof this.form.extraData !== 'undefined') {
                    this.ui.initPresetSettings(response.data, this.form);
                }
                if (this.isMinecraft()) {
                    this.ui.initMinecraftCustomSettings(response.data, this.form);
                }
                if (this.isValheim()) {
                    this.ui.initValheimMods();
                }

                this.ui.initMultipleStrings();
                initServerType();

                const galaxyData: any = (<any>window).galaxyData;
                if (typeof galaxyData != 'undefined') {
                    this.ui.initGalaxy(galaxyData);
                }

                const worldData: any = (<any>window).worldData;
                if (typeof worldData != 'undefined') {
                    this.ui.initWorld(worldData);
                }

                if ($('.expert-field').length > 0) {
                    new Expertmode();
                }

                initLayoutSwitcher();
                this.ui.showSettings();
            }).catch((error) => {
                console.log(error);
            });
        });
    }

    /**
     * Delete savegames
     */
    private deleteSavegames() {
        const gameserverId = window.gameserverId;
        const ajaxUrl: string = window.ajaxPath + '/deleteAllSavegame';
        this.loader.enable();
        this.ui.toggleDeleteSaveGameButton(false);
        Axios.post(ajaxUrl, {}, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-Requested-With': 'XMLHttpRequest'
            }
        }).then((response) => {
            this.loader.disable();
            new Notification('success',
                i18next.t('gameserver:configuration.delete_save_games_function.notifications.delete_save_games_success.title'),
                i18next.t('gameserver:configuration.delete_save_games_function.notifications.delete_save_games_success.text')
            );
            this.ui.toggleDeleteSaveGameButton(true);
            this.readConfig();
            // show notification
        }).catch((error) => {
            this.loader.disable();
            this.ui.toggleDeleteSaveGameButton(true);
            new Notification('danger',
                i18next.t('gameserver:configuration.delete_save_games_function.notifications.delete_save_games_error.title'),
                i18next.t('gameserver:configuration.delete_save_games_function.notifications.delete_save_games_error.text'));
    })

  }

    /**
     * Delete characters
     */
    private deleteCharacters() {
        const ajaxUrl: string = window.ajaxPath + '/deleteAllCharacter';
        this.loader.enable();
        this.ui.toggleDeleteCharacterButton(false);
        Axios.post(ajaxUrl, {}, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-Requested-With': 'XMLHttpRequest'
            }
        }).then((response) => {
            this.loader.disable();
            new Notification(
                'success',
                i18next.t('gameserver:configuration.delete_characters_function.notifications.delete_characters_success.title'),
                i18next.t('gameserver:configuration.delete_characters_function.notifications.delete_characters_success.text')
            );
            this.ui.toggleDeleteCharacterButton(true);
            this.readConfig();
            // show notification
        }).catch((error) => {
            this.loader.disable();
            this.ui.toggleDeleteCharacterButton(true);
            new Notification('danger',
                i18next.t('gameserver:configuration.delete_characters_function.notifications.delete_characters_error.title'),
                i18next.t('gameserver:configuration.delete_characters_function.notifications.delete_characters_error.text')
            );
        })

    }

    /**
     * Delete characters
     */
    private resetServerSettingsDefault() {
        const ajaxUrl: string = window.ajaxPath + '/resetSettingsToDefault';
        this.loader.enable();
        this.ui.toggleResetServerSettingsToDefault(false);
        Axios.post(ajaxUrl, {}, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-Requested-With': 'XMLHttpRequest'
            }
        }).then((response) => {
            this.loader.disable();
            new Notification(
                'success',
                i18next.t('gameserver:configuration.reset_server_settings_default_function.notifications.success.title'),
                i18next.t('gameserver:configuration.reset_server_settings_default_function.notifications.success.text')
            );
            this.ui.toggleResetServerSettingsToDefault(true);
            this.readConfig();
            // show notification
        }).catch((error) => {
            this.loader.disable();
            this.ui.toggleResetServerSettingsToDefault(true);
            new Notification('danger',
                i18next.t('gameserver:configuration.reset_server_settings_default_function.notifications.error.title'),
                i18next.t('gameserver:configuration.reset_server_settings_default_function.notifications.error.text')
            );
        })

    }
}

export function initConfiguration() {
    const instances: ConfigurationUI[] = createConfigurationUI();
    return instances.map((ui: ConfigurationUI) => {
        return new Configuration(ui);
    })
}
